<template>
    <div class="container">
        <div class="row">
            <div class="row page-content">
                <div class="col-12 p-0">
                    <h1 class="page-heading text-dark">
                        <img src="/assets/dipocaco/pocas/social.png" alt="collection-poca" class="page-poca">
                        {{ $t('social.title') }}
                    </h1>
                </div>

                <div class="col-12 mb-1 p-0" style="white-space: nowrap">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" role="presentation" v-on:click="tab = 'follows'">
                            <h5 class="nav-link active" id="current-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">
                                {{ $t('social.tabs.following') }}
                            </h5>
                        </li>
                        <li class="nav-item" role="presentation" v-on:click="tab = 'global'">
                            <h5 class="nav-link" id="sets-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">
                                {{ $t('social.tabs.global') }}
                            </h5>
                        </li>
                        <li class="nav-item" role="presentation" v-on:click="tab = 'search'">
                            <h5 class="nav-link" id="sets-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">
                                {{ $t('social.tabs.search') }}
                            </h5>
                        </li>
                    </ul>
                </div>

                <div class="col-12 p-0 row" v-if="loaded">
                    <template v-if="tab === 'follows' || tab === 'global'">
                        <div class="col-xxl-6 col-xl-6 col-12 p-1" v-for="posting in filteredPostings">
                            <posting :posting="posting" v-on:postingDeleted="loadFeed"></posting>
                        </div>

                        <div class="alert alert-info" v-if="filteredPostings.length === 0 && tab === 'follows'">
                            {{ $t('social.noFollowing') }}
                        </div>

                        <div class="alert alert-info" v-if="filteredPostings.length === 0 && hideBoosters">
                            {{ $t('social.onlyBoosters') }}
                        </div>

                        <div class="form-switch mb-2">
                            <input type="checkbox" class="form-check-input" id="hideBoosters" v-model="hideBoosters">
                            <label for="hideBoosters" class="form-check-label">{{ $t('social.hideBoosters') }}</label>
                        </div>
                    </template>

                    <div class="col-12 p-0 mt-2" v-if="tab === 'search'">
                        <div class="form-group">
                            <input type="search" class="form-control" :placeholder="$t('social.searchUsers')" v-model="searchTerm">
                        </div>

                        <div class="mt-4">
                            <a class="card mt-2 search-result bg-dark text-light" v-for="profileData in searchResults" :href="'/u/'+profileData.username">
                                <div class="card-body">
                                    <div class="avatar-image d-inline-block me-1">
                                        <img :src="'/assets/dipocaco/avatars/'+profileData.account.avatar.filename" alt="">
                                    </div>

                                    <div class="d-inline-block ms-2">
                                        <h4 class="mt-1 mb-0">{{ profileData.username }}</h4>
                                        <span class="mt-0 d-block">
                                            Level <strong class="mr-2">{{ getUserLevel(profileData) }}</strong> |
                                            <strong class="mr-2">{{ profileData.followers.length }}</strong> {{ $t('social.followers') }} |
                                            {{ $t('social.following') }} <strong class="mr-2">{{ profileData.followed_users.length }}</strong>
                                        </span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col-xxl-6 col-xl-6 col-12" v-else>
                    <loading-spinner/>
                </div>
            </div>
        </div>

        <card-detail-view-auto-load-canvas></card-detail-view-auto-load-canvas>
    </div>
</template>

<script>
import axios from "axios";
import Posting from "../parts/Posting.vue";
import CardDetailViewAutoLoadCanvas from "../parts/CardDetailViewAutoLoadCanvas.vue";
import LoadingSpinner from "../parts/LoadingSpinner.vue";

export default {
    name: "SocialFeed",
    components: {LoadingSpinner, CardDetailViewAutoLoadCanvas, Posting},
    data() {
        return {
            loaded: false,
            postings: [],
            onlyFollowing: true,
            followings: [],
            hideBoosters: false,
            searchTerm: '',
            searchResults: [],
            tab: 'follows'
        }
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.loadOwnFollowings();
        this.loadFeed();
    },
    watch: {
        onlyFollowing() {
            this.$forceUpdate();
        },
        searchTerm() {
            if (this.searchTerm.length > 0) {
                this.fetchSearchResults();
            }
        }
    },
    computed: {
        filteredPostings() {
            let filtered = this.postings;

            if (this.tab === 'follows') {
                filtered = filtered.filter(posting => this.followings.includes(posting.user_id));
            }

            if (this.hideBoosters) {
                filtered = filtered.filter(posting => !posting.pulled_booster);
            }

            return filtered;
        }
    },
    methods: {
        loadOwnFollowings() {
            axios.get('/api/social/followings').then((response) => {
                this.followings = response.data.map(f => f.followed_user_id);
                this.$forceUpdate();
            })
        },
        loadFeed() {
            axios.get('/api/social/feed').then((response) => {
                this.postings = response.data;
                this.loaded = true;
                this.$forceUpdate();
            })
        },
        fetchSearchResults() {
            axios.get(
                '/api/social/search?q='+this.searchTerm
            ).then((response) => {
                this.searchResults = response.data;
            }).catch((error) => {
                iziToast.error({
                    title: 'Error searching for users'
                });

                console.error(error);
            });
        },
        getUserLevel(profileData) {
            return (profileData.account.xp - (profileData.account.xp % 20_000)) / 20_000 + 1;
        }
    }
}
</script>

<style lang="scss" scoped>
.page-heading {
    background-image: url("/assets/dipocaco/pocas/social-poca_sm.jpg");
    background-position: center 50%;
}

.social-feed-selection {
    a {
        text-decoration: none;

        &.active {
            color: white !important;
        }
    }
}

.avatar-image {
    vertical-align: top;
    display: inline-block;
    max-width: 40%;
    border-radius: 1000px;
    border: 2px solid black;
    background-color: grey;

    img {
        max-width: 100%;
        max-height: 4em;
    }
}

.search-result {
    text-decoration: none;
}
</style>
